import React from "react";

import { connect } from "react-redux";
import { compose } from "redux";
import { withRouter } from "react-router-dom";

import { updateLoanStatusById } from "store/state/loan/loan";
import PrefDialog from "components/Global/Metric/PrefDialog";
import OptionsMenu from "components/Global/OptionsMenu/OptionsMenu";
import loanStatuses from "constants/loanStatuses";
import LoanAttachments from "./LoanAttachments";
import LoanNotes from "./LoanNotes";
import _ from "lodash";
import QuoteDuplicationConfirmationDialog from "components/Global/ConfirmationDialogs/QuoteDuplicationConfirmationDialog"
import {getLoansByPreferenceAndLoanStatus,} from 'store/state/loan/loan';

const LENDER_PASSED = "LenderPassedLoanTableColumns";
const SUBORDINATE_LOAN = "SubordinateLoanTableColumns";
const REJECTED_LOAN = "RejectedLoanTableColumns";
const SENIOR_LOAN = "SeniorLoanTableColumns";
const SUPPLEMENTAL_LOAN = "SupplementalLoanTableColumns";
const WINNING_QUOTE = "WinningQuoteTableColumns";

class LoanTableOptionsMenu extends React.Component {
  constructor(props) {
    super(props);
    this.state = {    
      modalOpen: false,
      isPrefDialogOpen: false,
      isAttachmentsOpen: false,
      isNotesOpen: false,
      options: [
        {
          id: 1,
          value: "Edit",
          onClick: () => {
            this.openLoan();
          },
          includeOnScreens: ["all"]
        },
        {
          id: 5,
          value: "Notes",
          onClick: optionId => {
            this.openNotes();
          },
          includeOnScreens: [
            LENDER_PASSED,
            SUBORDINATE_LOAN,
            REJECTED_LOAN,
            WINNING_QUOTE,
            SENIOR_LOAN,
            SUPPLEMENTAL_LOAN
          ]
        },
        {
          id: 6,
          value: "Attachments",
          onClick: optionId => {
            this.openAttachments();
          },
          includeOnScreens: [
            LENDER_PASSED,
            SUBORDINATE_LOAN,
            REJECTED_LOAN,
            WINNING_QUOTE,
            SENIOR_LOAN,
            SUPPLEMENTAL_LOAN
          ]
        },
        {
          id: 3,
          value: "Reject",
          onClick: () => {
            this.rejectLoan(() => {
              this.props.refreshGridCallback();
              this.props.expirationCallback();
            });
          },
          includeOnScreens: [SUBORDINATE_LOAN, SENIOR_LOAN, SUPPLEMENTAL_LOAN]
        },
        {
          id: 2,
          value: "Duplicate",
          onClick: optionId => {
            this.props.updateLoanStatusById({
            loanId: this.props.id,
            loanStatusId: loanStatuses.QUOTE,
            callback: this.props.refreshGridCallback,
            });
            this.openCloneConfirmDialog();
        },
          includeOnScreens: [SUBORDINATE_LOAN, SENIOR_LOAN, SUPPLEMENTAL_LOAN]
        },
      ]
    };
  }


  rejectLoan = callback => {
    this.props.updateLoanStatusById({
      loanId: this.props.id,
      loanStatusId: loanStatuses.REJECTED_QUOTE,
      callback: callback
    });
  };

  openLoan = () => {
    this.props.history.push(
      `/loan/edit/${this.props.match.params.dealId}/${this.props.id}`
    );
  };

  openNotes = () => {
    this.setState({ isNotesOpen: true });
  };

  closeNotes = () => {
    this.setState({ isNotesOpen: false });
  };

  openAttachments = () => {
    this.setState({ isAttachmentsOpen: true });
  };

  closeAttachments = () => {
    this.setState({ isAttachmentsOpen: false });
  };

  handlePrefDialogOpen = optionId => {
    this.setState({
      isPrefDialogOpen: optionId == 2
    });
  };

  handlePrefDialogClose = () => {
    this.setState({ isPrefDialogOpen: false });
    this.props.onClose();
  };


  openCloneConfirmDialog = (cloneId) => {
    this.setState({isCloneDialogOpen: true});
  }

  closeCloneDialog = () => {
    this.setState({isCloneDialogOpen:false});
  }

  pickAsWinner = () => {
    this.setState({
      modalOpen: false,
    });

    this.props.updateLoanStatusById({
      loanId: this.props.id,
      loanStatusId: loanStatuses.WINNING_QUOTE,
      callback: () => this.props.refreshGridCallback()
    });
  };
  
  cancelDialog = () => {
    this.setState({
      modalOpen: false,
    });
  };


  renderPrefDialog() {
    return (
      <PrefDialog
        isMetric={false}
        screenType={this.props.screenType}
        onClose={this.handlePrefDialogClose}
        isOpen={this.state.isPrefDialogOpen}
        prefData={this.props.metrics}
        maxCount={6}
      />
    );
  }

  render() {
    const { id } = this.props;
    const { isAttachmentsOpen, isNotesOpen, options,modalOpen } = this.state;
    const filteredOptions = options.filter(x => {
      return (
        x.includeOnScreens.includes("all") ||
        x.includeOnScreens.includes(this.props.tableName)
      );
    });
    return (
      <React.Fragment>
        <QuoteDuplicationConfirmationDialog 
            modalOpen={this.state.isCloneDialogOpen}
            handleNo={this.closeCloneDialog}
            handleYes={()=>{this.props.history.push(`/loan/${this.props.match.params.dealId}/${this.props.id}`)}}/> 
        {this.renderPrefDialog()}
        <OptionsMenu options={filteredOptions} maxHeight={400} />
        <LoanAttachments
          loanId={id}
          isOpen={isAttachmentsOpen}
          openAttachments={this.openAttachments}
          closeAttachments={this.closeAttachments}
        />
        <LoanNotes
          loanId={id}
          isOpen={isNotesOpen}
          openNotes={this.openNotes}
          closeNotes={this.closeNotes}
        />
      </React.Fragment>
    );
  }
}

const mapStateToProps = ({}) => ({});

export default compose(
  connect(
    mapStateToProps,
    { updateLoanStatusById,
      getLoansByPreferenceAndLoanStatus,
     }
  )
)(withRouter(LoanTableOptionsMenu));
